import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/config'; // Initialize i18n
import { initCreAgentMode } from './cre/agentMode/creAgentMode';
import App from './App';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './utils/queryClient';
import reportWebVitals from './reportWebVitals';

// Suppress Twilsock timeout errors globally - these are expected Twilio SDK behavior
// and don't affect functionality. The SDK handles retries internally.
// Set up error handlers immediately after imports to catch errors early
if (typeof window !== 'undefined') {
  // Suppress console errors for Twilsock timeouts
  const originalConsoleError = console.error;
  console.error = function(...args) {
    const message = args.join(' ');
    if (/Twilsock.*request timeout|TM[0-9a-f-]{8,}|_conversationsPromise/i.test(message)) {
      // Silently suppress Twilsock timeout errors
      return;
    }
    originalConsoleError.apply(console, args);
  };
  
  // Suppress unhandled promise rejections for Twilsock timeouts (must be first listener)
  const unhandledRejectionHandler = (event) => {
    const error = event.reason;
    const errorMessage = error?.message || error?.toString() || '';
    if (/Twilsock.*request timeout|TM[0-9a-f-]{8,}|_conversationsPromise/i.test(errorMessage)) {
      event.preventDefault(); // Prevent error from showing in console/overlay
      event.stopPropagation(); // Stop event from propagating
      return false;
    }
  };
  window.addEventListener('unhandledrejection', unhandledRejectionHandler, true);
  
  // Also catch general errors (must be first listener)
  const errorHandler = (event) => {
    const errorMessage = event.message || event.error?.message || '';
    if (/Twilsock.*request timeout|TM[0-9a-f-]{8,}|_conversationsPromise/i.test(errorMessage)) {
      event.preventDefault(); // Prevent error from showing in console/overlay
      event.stopPropagation(); // Stop event from propagating
      return false;
    }
  };
  window.addEventListener('error', errorHandler, true);
}

// CRE Agent Mode (?agent=1, opened by the Windows agent) — read before auth redirects rewrite the URL.
initCreAgentMode();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <div className='bg-gray-100'>
      <main>
        <App />
      </main>
    </div>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
